import { primitive } from 'styles/constants/primitives';

import { RadialGradientConfig } from '../action-button-radial-gradient';

const DARK_BLUE = '#2062a2';
const MEDIUM_BLUE = '#70cbec';
const LIGHT_BLUE = '#bdecdfff';
const GOLD = '#F2C337';

export const spongebob = {
  splashScreen: { lottie: require('./bubbles.json'), audio: require('./im-spongebob.m4a') },
  menuIcon: require('./menu-icon.png'),
  primaryActionButton: {
    backgroundColor: GOLD,
    _text: {
      color: primitive.bk.$bbqBrown,
    },
    _pressed: {
      backgroundColor: '#e3b330',
    },
  },
  primaryActionButtonRadialGradient: {
    center: { x: 0.5, y: 0.75 },
    radius: { x: 4, y: 4 },
    stops: [
      { color: '#FFF', offset: 0, opacity: 0.6 },
      { color: GOLD, offset: 0.2, opacity: 0 },
    ],
  } as RadialGradientConfig,
  homePage: {
    targetSimpleHomePageIds: [
      // lunch simple home page
      '6cc4cd5a-9a89-49ca-a683-b5c741359b81',

      // breakfast simple home page
      'ef2c0a58-d7a1-44fd-91de-6c811f15f2ec',
    ],
    containerBackgroundColor: DARK_BLUE,
    secondaryCtaButtonColor: null,
    secondaryCtaFontColor: primitive.bk.$white,
  },
  menu: {
    targetSectionIds: [
      // legacy - lunch meals
      '463b62de-01b7-4af7-b5ea-6d6337dfb142',

      // legacy - breakfast meals
      'section_4833',
    ],
    sectionBackgroundColor: MEDIUM_BLUE,
    sectionLottie: require('./bubbles.json'),
  },
  menuSection: {
    headerBackgroundColor: MEDIUM_BLUE,
    itemBackgroundColor: LIGHT_BLUE,
    transitionLottie: require('./bubbles.json'),
    transitionAudio: require('./im-spongebob.m4a'),
  },
  pdp: {
    targetMenuItemIds: [
      // legacy - combos non 1m
      '1b024440-71e2-4566-900a-40fceaf5640b',
      'ec9b5960-3068-40ef-93d3-4837a687042c',
      '756793e9-12b7-4627-a1a8-238295605570',
      '22407a11-b4ce-4778-bc73-1bdb5e193771',
      '1c426c91-cd09-4291-8344-97855c53cf1b',
      'b120fcbc-3533-4c60-ac4f-cdde3e8ce489',
      '0c71ed7d-0ab6-4a0f-a205-de8e942ecd9d',
      '26851bb0-79fc-4fe7-9e22-3727994ab979',
      '8ed0a369-ac31-4471-9d3a-766100258a95',
      '7ff43c2a-7520-4f35-9ad0-0d1cbc4a0cdf',
      '26e33f7d-efbf-4e22-ab92-32eb00aab838',
      '14625e6e-d4a7-43c1-9f84-04d398ee18f9',

      //legacy - breakfast meals
      'a94f7d4b-1638-46b6-9239-29e1371713aa',
      '02a7b168-d326-4566-97d8-b51219f74860',
      'picker_4737',
      'picker_4735',
      'picker_4738',
      'picker_4739',
      'picker_4743',
      'a9ded791-1e24-4f08-86bc-a488d0194d01',
      'gy2bPvBhhRgPFSSGaFE3r4',
      'picker_4749',
    ],
    headerBackgroundColor: MEDIUM_BLUE,
    backgroundColor: LIGHT_BLUE,
    transitionAudio: require('./im-spongebob.m4a'),
    drinkAudio: require('./im-spongebob.m4a'),
    sideAudio: require('./im-spongebob.m4a'),
  },
};
